module.exports = __webpack_public_path__ + "98571f9ad3da5a004de6d941ed127ea3.png";